export default {"src":"/_next/static/media/WowTech.fa17c1e4.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};